


























































































































































































import Qrcode from 'vue-qrcode';
import BarCode from 'vue-barcode';
import { Vue, Component, Prop } from 'vue-property-decorator';
import { namespace } from 'vuex-class';

import Accordion from '@/shared/components/Accordion/Accordion.vue';

import { Payment } from '@/classes/Checkout/Payment';

import { EPaymentMethod, EPaymentMethodTypes } from '@/helpers/enums';
import { goToExternal } from '@/helpers/redirects';
import { copyToClipboard } from '@/helpers/dom';

import * as CardIcon from '@/assets/images/payment/card/nobrand.svg';
import * as PixIcon from '@/assets/images/payment/pix/pix.svg';
import * as BankSlipIcon from '@/assets/images/payment/bankslip/boleto.svg';
import * as PicpayIcon from '@/assets/images/payment/wallet/picpay.svg';
import * as AtarpayIcon from '@/assets/images/payment/wallet/atarpay.svg';
import * as MercadoPagoIcon from '@/assets/images/payment/wallet/mercado_pago.svg';
import * as BBIcon from '@/assets/images/payment/bank/bb.svg';
import * as BradescoIcon from '@/assets/images/payment/bank/bradesco.svg';
import * as CaixaIcon from '@/assets/images/payment/bank/caixa.svg';
import * as ItauIcon from '@/assets/images/payment/bank/itau.svg';
import * as SantanderIcon from '@/assets/images/payment/bank/santander.svg';
import * as OriginalIcon from '@/assets/images/payment/bank/original.svg';
import * as Bs2Icon from '@/assets/images/payment/bank/bs2.svg';
import * as InterIcon from '@/assets/images/payment/bank/inter.svg';

import { EBankCodes } from '@/entities/Bank';

import KoinPaymentFeedback from './Koin/KoinPaymentFeedback.vue';
import CreditCardPixPaymentFeedback from './CreditCardPix/CreditCardPixPaymentFeedback.vue';

const CheckoutModule = namespace('App/Checkout');

@Component({
  components: {
    Qrcode,
    BarCode,
    Accordion,
    KoinPaymentFeedback,
    CreditCardPixPaymentFeedback,
  },
})
export default class PaymentFeedback extends Vue {
  @Prop()
  private readonly isRenew!: boolean;

  @Prop()
  private readonly hasUpsell!: boolean;

  @Prop()
  private readonly payment!: Payment;

  @Prop()
  private readonly instructions!: any;

  @Prop()
  private readonly appLinkUrl!: string;

  private copyTextMessage: string = 'Texto copiado com sucesso!';

  private showCopyFeedback: boolean = false;

  @CheckoutModule.Getter('bankSlipAcceptedTermsChecked')
  private acceptedTermsChecked!: boolean;

  @CheckoutModule.Getter
  private disableBankSlipInstallments!: boolean;

  @CheckoutModule.State(state => state.contract)
  private contract!: any;

  private goToPostSuccessURL () {
    return goToExternal(this.customButtonSuccess.url);
  }

  private copyValueToClipboard (value: any): void {
    if (this.paymentTypeIsPix) {
      this.copyTextMessage = 'Código Pix copiado';
    }

    copyToClipboard(value);

    this.showCopyFeedback = true;
  }

  private get showVerify () {
    return false;
  }

  private get isFreeOrder () {
    return this.instructions.amount <= 0;
  }

  private get pixCode () {
    return this.instructions.pix_code;
  }

  private get paymentTypeIsPix () {
    return this.paymentMethodType === this.paymentMethodTypes.pix;
  }

  private get canShowQrCodeOnPix () {
    return this.paymentTypeIsPix;
  }

  private get bankslip () {
    return this.payment.getPaymentMethod(EPaymentMethod.bankSlip);
  }

  private get paymentMethodTypeByMethod () {
    return this.payment.getTypeOfPaymentMethod(this.instructions.payment_method_code);
  }

  private get paymentMethod () {
    return this.instructions.payment_method_code;
  }

  private get paymentMethodType () {
    return this.paymentMethodTypeByMethod &&
      this.paymentMethodTypeByMethod.type;
  }

  private get paymentMethodTypes () {
    return EPaymentMethodTypes;
  }

  private get wireTransferIcon () {
    const { payment_profile, transfer_metadata } = this.instructions;
    let bankCode = '';

    if (payment_profile) {
      bankCode = payment_profile.bank_code;
    } else if (transfer_metadata) {
      bankCode = transfer_metadata.beneficiary.bank;
    }

    switch (bankCode) {
      case EBankCodes.bb:
        return BBIcon;
      case EBankCodes.caixa:
        return CaixaIcon;
      case EBankCodes.santander:
        return SantanderIcon;
      case EBankCodes.bradesco:
        return BradescoIcon;
      case EBankCodes.itau:
        return ItauIcon;
      case EBankCodes.bs2:
        return Bs2Icon;
      case EBankCodes.inter:
        return InterIcon;
      case EBankCodes.original:
        return OriginalIcon;
      default:
        return '';
    }
  }

  private get iconByPaymentMethodType () {
    switch (this.paymentMethodType) {
      case EPaymentMethodTypes.creditCard:
        return CardIcon;
      case EPaymentMethodTypes.pix:
        return PixIcon;
      case EPaymentMethodTypes.bankSlip:
        return BankSlipIcon;
      case EPaymentMethodTypes.wireTransfer:
        return this.wireTransferIcon;
      default:
        return '';
    }
  }

  private get feedbackText () {
    const text = this.$t(`App.Checkout.success.instructions.${this.messagePaymentMethod}${this.isMobile ? '.mobile' : ''}.${this.isRenew ? 'renewal.' : ''}${this.hasUpsell ? 'upsell.' : ''}text`);

    return String(text).replace(new RegExp('APP_LINK_URL', 'g'), this.appLinkUrl);
  }

  private get isMobile () {
    return this.$vuetify.breakpoint.smAndDown;
  }

  private get messagePaymentMethod () {
    return this.isFreeOrder
      ? EPaymentMethod.creditCard
      : this.paymentMethod;
  }

  private get customButtonSuccess () {
    return {
      text: this.instructions.targetContentLink && this.instructions.targetContentLink.text || 'Ir para minhas publicações',
      url: this.instructions.targetContentLink && this.instructions.targetContentLink.url || 'https://publicacoes.empiricus.com.br/dashboard',
    };
  }

  private get timeToExpireBankslipText () {
    return this.instructions.bankslip_expiration_days === 1
      ? 'dia útil'
      : 'dias úteis';
  }

  private get isKoin() {
    return (!this.isRenew && this.instructions
    && this.instructions.payment_method_code === EPaymentMethod.bankSlip && this.instructions.payment_conditions && this.instructions.payment_conditions[0].installments.number > 1)
    || (this.isRenew && this.instructions && this.instructions.broker === 'koin');
  }

  private get statusPayment() {
    return this.isRenew ? this.contract && this.contract.order && this.contract.order.status : this.instructions.status;
  }

  private get isCreditCardPix() {
    return (!this.isRenew && this.instructions
      && this.instructions.payment_conditions
      && this.instructions.payment_conditions.length > 0
      && this.instructions.payment_conditions.some((value: any) => value.payment_method_code === EPaymentMethod.creditCard)
      && this.instructions.payment_conditions.some((value: any) => value.payment_method_code === EPaymentMethod.pix))
      || (this.isRenew && this.contract && this.contract.payment
        && this.contract.payment.payment_method_code && this.contract.payment.payment_method_code === EPaymentMethod.pix
        && this.paymentMethodType === this.paymentMethodTypes.creditCard);
  }
}
